import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cad-cam',
  templateUrl: './cad-cam.component.html',
  styleUrls: ['./cad-cam.component.scss']
})
export class CadCamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
